/**
 * Public API for Behavior module
 *
 * Ported from [behavior@22bd882f8f](https://github.com/optimizely/optimizely/blob/22bd882f8f9ab8db0f8b8a40785dd96a80782b41/src/www/js/client/behavior.js)
 * @module
 */

var BehaviorStore = require('./store');

/**
 * Initialize BehaviorStore
 * @param {BehaviorVerboseEvent[]|BehaviorCompactEvent[]} storedEvents
 */
exports.initializeStore = BehaviorStore.initialize;

/**
 * Add event to store
 * @param {BehaviorEventSpec} event
 * @param {Object} eventTags
 */
exports.addEvent = BehaviorStore.addEvent;

/**
 * Get events from store
 * @returns {module:behavior/event~Event[]}
 */
exports.getEvents = BehaviorStore.getEvents;

/**
 * Get count of events in store
 * @returns {number}
 */
exports.getEventCount = BehaviorStore.getEventCount;
